<template>
  <div id="loading">
    <div ref="container" class="loading-container"></div>
    <p class="loading-percent">
      {{ Math.floor((loaded / total) * 100) + "%" }}
    </p>
    <div class="loading-bar">
      <div class="bar-border"></div>
      <div
        class="bar-solid"
        :style="{ width: (loaded / total) * 100 + '%' }"
      ></div>
    </div>
    <div v-if="showTask" class="loading-text">
      <p v-for="(i, index) in texts" :key="index">{{ i }}</p>
    </div>
    <p id="version" v-if="version">{{ version }}</p>
  </div>
</template>

<script>
import assets from "./assets.js";
export default {
  data() {
    return {
      showTask: process.env.VUE_APP_MODE !== "prod",
      loaded: 0,
      total: 0,
      texts: ["开始加载。。。"],
    };
  },
  props: {
    version: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.$Spinner.showLoading(this.$refs.container, false, true, true);
    this.loadAssets();
  },
  methods: {
    loadAssets() {
      // 预处理图片
      let imgs = assets.imgs,
        imgLoads = [];
      imgs.forEach((img) => {
        imgLoads.push(this.loadImg(img));
      });
      this.total += imgs.length;
      // 加载接口相关
      let fns = assets.fns,
        fnLoads = [];
      fns.forEach((fn) => {
        fnLoads.push(this.doFn(fn));
      });
      this.total += fns.length;
      let sounds = assets.sounds,
        soundLoads = [];
      sounds.forEach((sound) => {
        soundLoads.push(this.loadSound(sound));
      });
      this.total += sounds.length;
      Promise.all([].concat(imgLoads, fnLoads, soundLoads)).then((res) => {
        this.onCompleted();
      });
    },
    // 加载图片
    loadImg(img) {
      return new Promise((resolve) => {
        let imgDom = document.createElement("img");
        imgDom.src = img.src;
        imgDom.style.position = "absolute";
        imgDom.style.zIndex = "-1";
        imgDom.style.top = "-10000px";
        imgDom.width = 0;
        imgDom.height = 0;
        document.body.append(imgDom);
        this.texts.push(`图片加载：${img.name}`);
        imgDom.onload = () => {
          this.loaded++;
          imgDom.remove();
          // this.texts.push(`成功加载图片：${img.name}`);
          this.texts.splice(
            this.texts.findIndex((i) => i == `图片加载：${img.name}`),
            1
          );
          resolve();
        };
      });
    },
    // 执行方法
    doFn(fn) {
      return new Promise((resolve) => {
        this.texts.push(`接口调用：${fn.name}`);
        fn.fn().then((res) => {
          this.loaded++;
          // this.texts.push(`成功调用接口：${fn.name}`);
          this.texts.splice(
            this.texts.findIndex((i) => i == `接口调用：${fn.name}`),
            1
          );
          resolve();
        });
      });
    },
    // 加载声音
    loadSound(sound) {
      return new Promise((resolve) => {
        let audioDom = document.createElement("audio");
        audioDom.id = sound.id;
        // audioDom.innerHTML = `<source src="${sound.src}" type="audio/mpeg" />`;
        audioDom.preload = "auto";
        audioDom.src = sound.src;
        document.body.appendChild(audioDom);
        this.texts.push(`音频加载：${sound.name}`);
        audioDom.load();
        audioDom.oncanplaythrough = () => {
          this.loaded++;
          // this.texts.push(`成功加载音频：${sound.name}`);
          this.texts.splice(
            this.texts.findIndex((i) => i == `音频加载：${sound.name}`),
            1
          );
          resolve();
        };
      });
    },
    // 加载完成
    onCompleted() {
      this.$Spinner.hideLoading(this.$refs.container);
      this.$emit("onCompleted");
    },
  },
};
</script>

<style lang='scss' scoped>
#loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  // pointer-events: none;
  opacity: 1;
  transition: all 1s linear;
  max-width: 750px;
  margin: auto;

  .loading-percent {
    position: absolute;
    top: 0;
    bottom: -0.8rem;
    left: 0;
    right: 0;
    width: 50%;
    height: 0.78rem;
    margin: auto;
    line-height: 0.78rem;
    color: #fff;
    text-align: center;
    background-image: linear-gradient(
      to right,
      transparent 0%,
      rgba(#276689, 0.3) 25%,
      rgba(#276689, 0.3) 75%,
      transparent 100%
    );
    text-shadow: 0 -2px 0 #3a2c09, 2px 0 0 #3a2c09, 0px 2px 0 #3a2c09,
      -2px 0 0 #3a2c09;
  }
}

.loading-container {
  position: relative;
  height: 100%;
  margin-top: -0.8rem;
}

.leave {
  opacity: 0 !important;
  transform: scale(1.2);
}

.loading-bar {
  position: absolute;
  top: 0.76rem;
  bottom: -0.8rem;
  left: 0;
  right: 0;
  width: 3.88rem;
  height: 0.13rem;
  margin: auto;

  .bar-border,
  .bar-solid {
    width: 3.88rem;
    height: 0.13rem;
  }

  .bar-border {
    @include bgImg("root/exp-bar_bg.png");
    z-index: 1 !important;
  }

  .bar-solid {
    @include bgImg("root/exp-bar_solid.png");
    background-size: 100% 0.2rem;
    margin-left: 0.02rem;
    z-index: 2 !important;
  }
}

.loading-text {
  position: absolute;
  top: 4rem;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  margin: auto;
  height: 2rem;
  width: 6rem;
  overflow: auto;
  text-align: center;
  background: rgba(#000, 0.3);
}
</style>